import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface PhoneCollectionState {
  needsPhoneCollection: boolean
  showPhoneModal: boolean
  preference: 'unknown' | 'saved' | 'skipped' | 'not-interested'
}

const initialState: PhoneCollectionState = {
  needsPhoneCollection: false,
  showPhoneModal: false,
  preference: 'unknown',
}

export const phoneCollectionSlice = createSlice({
  name: 'phoneCollection',
  initialState,
  reducers: {
    setNeedsPhoneCollection: (state, action: PayloadAction<boolean>) => {
      state.needsPhoneCollection = action.payload
    },
    showPhoneCollectionModal: (state) => {
      state.showPhoneModal = true
    },
    hidePhoneCollectionModal: (state) => {
      state.showPhoneModal = false
    },
    setPhonePreference: (state, action: PayloadAction<'saved' | 'skipped' | 'not-interested'>) => {
      state.preference = action.payload
      if (action.payload === 'not-interested') {
        state.needsPhoneCollection = false
      }
    },
    resetPhoneCollection: (state) => {
      state.needsPhoneCollection = false
      state.showPhoneModal = false
    },
  },
})

export const {
  setNeedsPhoneCollection,
  showPhoneCollectionModal,
  hidePhoneCollectionModal,
  setPhonePreference,
  resetPhoneCollection,
} = phoneCollectionSlice.actions

export default phoneCollectionSlice.reducer
